import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import {Link} from "react-router-dom";
import {Box, Button} from "rebass";
import {DesktopBox, MobileBox, PositionBox} from "./index";
import IosSearchOutline from 'react-ionicons/lib/IosSearchOutline'
import MdAdd from 'react-ionicons/lib/MdAdd'

// const IS_FULLSCREEN = window.matchMedia('(display-mode: standalone)').matches


export const DesktopButton = styled(Button)`
border-radius: 43.881px;
box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
//width: 200px;
//height: 50px;
overflow: hidden;
`;

const StyledButton = styled(Button)`
  z-index: 99999999;
  min-height: 50px;
  min-width: 50px; 
  max-height: 50px;
  max-width: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);

  svg {
    color: white;
  }
`;

const StyledPlus = styled(MdAdd)`
	margin-left: -3px;
	margin-top: 1px;
`

export const AddButton = ({to, desktop, mobile, bg, ...rest}) => {
	return (
		<Fragment>
			<DesktopBox><Link to={to}><DesktopButton {...desktop} mx={2} my={2} variant='main' bg={bg}>Create
				New</DesktopButton></Link></DesktopBox>
			<MobileBox>
				<PositionBox position={['fixed']}
				             top={window.matchMedia('(display-mode: standalone)').matches ? ['80vh'] : ['80vh']} right={[22]}
				             zIndex={['999']}>
					<Link to={to}><StyledButton {...mobile} borderRadius='50px' bg={bg}><StyledPlus color={'white'} fontSize={'25px'}/></StyledButton></Link>
				</PositionBox>

			</MobileBox>
		</Fragment>
	);
};

AddButton.propTypes = {
	to: PropTypes.string,
	bg: PropTypes.string
};

AddButton.defaultProps = {
	to: '/posts/new',
	bg: 'purple'
};


const StyledFloatingButton = styled(Button)`
  z-index: 99999999;
  height: 50px;
  width: 50px;
  svg {
    color: white;
  }
`;

export const FloatingButton = ({children, color, bg, bottom, ...rest}) => (
	<PositionBox position={['fixed']} bottom={bottom} zIndex={'99999'} right={'22px'}>
		<StyledFloatingButton color={color} bg={bg} m={1} borderRadius='50px' {...rest}>
			{children}
		</StyledFloatingButton>
	</PositionBox>
);

FloatingButton.defaultProps = {
	bottom: '22px',
	color: 'black',
	bg: 'purple'
};


const SearchWrapper = styled(Button)`
 max-height: 40px;
`;

export const SearchButton = (props) => (
	<SearchWrapper p={0} m={0} bg={'transparent'} {...props}>
		<IosSearchOutline fontSize={'25px'}/>
	</SearchWrapper>
);

const PrimaryStyledButton = styled(Box)`
  //height: 25px;
  //width: 25px;
  border-radius: 50px;
  align-content: center;
`;

export const PrimaryButton = (props) => (<PrimaryStyledButton {...props}/>);


export const SaveButton = styled(Button)`
border-radius: 43.881px;
box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
width: 167px;
height: 50px;
overflow: hidden;
`;